import { render, staticRenderFns } from "./CallCenterForm.vue?vue&type=template&id=0b175989"
import script from "./CallCenterForm.vue?vue&type=script&lang=js"
export * from "./CallCenterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports